import { getOrderedActivityProfiles } from "PFApp/helpers/get_ordered_activity_profiles";
import { getActiveActivityProfiles } from "PFCore/helpers/get_active_activity_profiles";
import { Activity, Owner, Profile } from "PFTypes";
import { useMemo } from "react";

import { useActivityTemplateType } from "../../../activities/hooks";
import { useCanViewParticipants } from "./use_can_view_participants";

type OwnersResult = {
  owners: Profile[];
  principalOwner?: Profile;
  canView: boolean;
  canWrite: boolean;
};

export const useOwners = (activity?: Partial<Activity>): OwnersResult => {
  const { canViewParticipants } = useCanViewParticipants();

  const activeOwners = getActiveActivityProfiles<Owner>(activity?.owners || []);
  const principalOwner = activeOwners.find((item) => item.principal)?.profile;

  const owners = useMemo(
    () =>
      getOrderedActivityProfiles(
        activeOwners.filter(({ principal }) => !principal).map(({ profile }) => profile)
      ),
    [activeOwners]
  );

  const { isRole, isEngagement } = useActivityTemplateType(activity);
  const canWrite = (isRole || isEngagement) && !!activity?.coowned;

  const canView = owners.length > 0 && !!activity && canViewParticipants(activity as Activity);

  return { owners, principalOwner, canView, canWrite };
};
